import { render } from "./AdminStart.vue?vue&type=template&id=090ac9ab&scoped=true"
import script from "./AdminStart.vue?vue&type=script&lang=js"
export * from "./AdminStart.vue?vue&type=script&lang=js"

import "./AdminStart.vue?vue&type=style&index=0&id=090ac9ab&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090ac9ab"]])

export default __exports__